import { render, staticRenderFns } from "./DevirModalServis.vue?vue&type=template&id=71e6b030&"
import script from "./DevirModalServis.vue?vue&type=script&lang=js&"
export * from "./DevirModalServis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports